import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { Project } from '../projects/project.model';
import { ProjectService } from '../projects/project.service';

import { Campaign } from '../campaigns/campaign.model';
import { CampaignService } from '../campaigns/campaign.service';

@Injectable()
export class SharedDataService {
  private project = new BehaviorSubject(undefined);
  private campaign = new BehaviorSubject(undefined);

  private fetchingProject: boolean;
  private fetchingCampaign: boolean;

  constructor(
    private pservice: ProjectService,
    private cservice: CampaignService
  ) { }

  private isDef(val) {
    return val !== void 0;
  }

  getProject() {
    return this.project.asObservable();
  }

  awaitProject(id) {
    if (this.project.hasError) {
      this.project = new BehaviorSubject(undefined);
      this.campaign = new BehaviorSubject(undefined);
    }

    let current_project = this.project.getValue();

    if (!this.isDef(current_project) && !this.fetchingProject) {
      this.refreshProject(id);
    } else if (!this.fetchingProject && current_project['id'] !== id) {
      this.project = new BehaviorSubject(undefined);
      this.campaign = new BehaviorSubject(undefined);
      this.refreshProject(id);
    }

    return this.getProject();
  }

  refreshProject(id) {
    this.fetchingProject = true;

    this.pservice.getProject(id).subscribe(result => {
      this.fetchingProject = false;
      this.project.next(result['project']);
    }, err => {
      this.fetchingProject = false;
      this.project.error(err);
    });
  }

  getCampaign() {
    return this.campaign.asObservable();
  }

  awaitCampaign(id) {
    if (this.campaign.hasError) {
      this.project = new BehaviorSubject(undefined);
      this.campaign = new BehaviorSubject(undefined);
    }

    let current_campaign = this.campaign.getValue();

    if (!this.isDef(current_campaign) && !this.fetchingCampaign) {
      this.refreshCampaign(id);
    } else if (!this.fetchingCampaign && current_campaign['id'] !== id) {
      this.campaign = new BehaviorSubject(undefined);
      this.refreshCampaign(id);
    }

    return this.getCampaign();
  }

  refreshCampaign(id) {
    this.fetchingCampaign = true;
    this.cservice.getCampaign(id).subscribe(result => {
      this.awaitProject(result['campaign']['project_id']).subscribe(project => {
        if (!!project) {
          this.fetchingCampaign = false;
          this.campaign.next(result['campaign']);
        }
      }, err => {
        console.log(err);
      });
    }, err => {
      this.fetchingCampaign = false;
      this.campaign.error(err);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/data.service.ts